export const findStatusFromNumericVal = (val) => {
  switch (val) {
    case 2:
      return "ACTIVE";
    case 3:
      return "INACTIVE";
    default:
      return "all";
  }
};
export const findPlanFromNumericVal = (val) => {
  switch (val) {
    case 2:
      return "free";
    case 3:
      return "premium";
    default:
      return "all";
  }
};

// true = OTP verified (status is ACTIVE or INACTIVE), false = not yet
// verified (status is still PENDING) — see Neo-backend's
// SignupVerificationFinalize, the only place a user ever leaves PENDING.
export const findVerifiedFromNumericVal = (val) => {
  switch (val) {
    case 2:
      return true;
    case 3:
      return false;
    default:
      return undefined;
  }
};

export const findMetricTypeFromNumericVal = (numericVal) => {
  switch (numericVal) {
    case 2:
      return "ENGAGED_USERS";
    case 3:
      return "DELETED_USERS";
    case 4:
      return "IDLE_USERS";
    case 5:
      return "SIGNUPS";
    default:
      return null;
  }
};
